import { useSelector } from "react-redux";
import get from "lodash/get";
const _ = { get };

export const validation = (name, value, elements) => {
  if (name === "email") {
    if (value.length === 0) {
      return _.get(
        elements,
        "euToursElement.validationsElement.emailRequiredValidation",
        "Email is required"
      );
    } else if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(value)) {
      return _.get(
        elements,
        "euToursElement.validationsElement.notValidEmailValidation",
        "Please enter valid email"
      );
    }
  }
  if (name === "bio") {
    if (value.length > 450) return "Max Bio Length is 450 character";
  }
  if (name === "primaryNumber" || name === "secondaryNumber") {
    // if (!/^(?!0+$)\d{8,}$/.test(value)) {
    //   return _.get(
    //     elements,
    //     "euToursElement.validationsElement.invalidContactNumberValidation",
    //     "Invalid contact number"
    //   );
    // }
    if (value.length < 8) {
      return _.get(
        elements,
        "euToursElement.validationsElement.contactNumberLengthValidation",
        "Contact number should be between 8 - 15 characters"
      );
    }
    if (value.length > 15) {
      return _.get(
        elements,
        "euToursElement.validationsElement.contactNumberLengthValidation",
        "Contact number should be between 8 - 15 characters"
      );
    }
  }
  // if (name === "secondaryNumber") {
  //   // if (!/^(?!0+$)\d{8,}$/.test(value)) {
  //   //   return _.get(
  //   //     elements,
  //   //     "euToursElement.validationsElement.invalidContactNumberValidation",
  //   //     "Invalid contact number"
  //   //   );
  //   // }
  //   if (value.length < 8) {
  //     return _.get(
  //       elements,
  //       "euToursElement.validationsElement.contactNumberLengthValidation",
  //       "Contact number should be between 8 - 15 characters"
  //     );
  //   }
  //   if (value.length > 15) {
  //     return _.get(
  //       elements,
  //       "euToursElement.validationsElement.contactNumberLengthValidation",
  //       "Contact number should be between 8 - 15 characters"
  //     );
  //   }
  // }
  if (name === "regionRating") {
    if (value.length === 0) {
      return _.get(
        elements,
        "euToursElement.validationsElement.regionRatingValidation",
        "Region rating is required"
      );
    }
  }
  if (name === "countryRating") {
    if (value.length === 0) {
      return _.get(
        elements,
        "euToursElement.validationsElement.countryRatingValidation",
        "Country rating is required"
      );
    }
  }
  if (name === "establishYear") {
    if (value.length === 0) {
      return _.get(
        elements,
        "euToursElement.validationsElement.establishedYearValidation",
        "Establish year is required"
      );
    }
  }
  if (name === "name") {
    if (!/^[A-Za-z][A-Za-z0-9 /",-@$#%_:]*$/.test(value)) {
      return _.get(
        elements,
        "euToursElement.validationsElement.nameValidation",
        "The name must contain only Alphabets"
      );
    }
    if (value.length > 150) {
      return _.get(
        elements,
        "euToursElement.validationsElement.maxLengthValidation",
        "Max length is 150"
      );
    }
  }
  if (
    name === "thumbnailImage" ||
    name === "images" ||
    name === "image" ||
    name === "thumbnailListingDesktop" ||
    name === "thumbnailListingMobile" ||
    name === "thumbnailDetailDesktop" ||
    name === "thumbnailDetailMobile" ||
    name === "thumbnailDetailBannerDesktop" ||
    name === "thumbnailDetailBannerMobile" ||
    name === "thumbnailPartnerImage"
  ) {
    if (value > 1000000) {
      return _.get(
        elements,
        "euToursElement.validationsElement.thumbnailImageSizeValidation",
        "The size of the image should be less than 1 mb"
      );
    }
  }
  if (name === "video") {
    if (value > 10000000) {
      return _.get(
        elements,
        "euToursElement.validationsElement.videoSizeValidation",
        "The size of the video should be less than 10 mb"
      );
    }
  }
};
